





































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import { AxiosError } from "axios";
import CustomTable from "@/components/form/CustomTable.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { Disk, DiskEdit, DiskList } from "@/api-v2/files/models";
import Modal from "@/components/form/Modal.vue";
import CField from "@/components/form/CField.vue";
import { fileApi } from "@/getinfo-api";
import disksList, { DiskApiListParams } from "@/getinfo-api/fileManagerDisks";

@Component({
  components: {
    CField,
    Modal,
    CustomTableCol,
    CustomTableItem,
    CustomButton,
    CBlock,
    CustomTable
  }
})
export default class AdminControl extends Vue {
  @Prop() disk!: Disk;
  @Prop() diskId!: string;

  localDisk!: Disk;
  formEditDisk: DiskEdit = {
    title: "",
    ownerId: "",
    spaceLimit: 0
  };

  data() {
    return {
      localDisk: undefined
    };
  }

  openEditDisk() {
    this.formEditDisk.title = this.localDisk.title;
    this.formEditDisk.ownerId = this.localDisk.owner.id;
    this.formEditDisk.spaceLimit = this.localDisk.spaceLimit;
  }

  editDisk() {
    if (this.formEditDisk.spaceLimit < this.localDisk.spaceUsed) {
      this.$store.dispatch(
        "localError",
        `${this.$tc(
          this.$translate.TheDiskVolumeCannotBeLessThanTheOccupiedSpace
        )}`
      );
    } else {
      fileApi.DiskApi.update(this.localDisk.id, this.formEditDisk)
        .then(res => {
          this.localDisk = res.data;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  @Watch("disk")
  watchDisk() {
    this.localDisk = this.disk;
  }

  getDisk(id: string) {
    let params: DiskApiListParams = {
      ids: [id]
    };
    disksList(params).then((res: { data: DiskList }) => {
      this.localDisk = res.data.items[0];
    });
  }

  created() {
    if (this.disk) {
      this.localDisk = this.disk;
    } else if (this.diskId) {
      this.getDisk(this.diskId);
    }
  }
}
